import { ChartTooltipData } from './ChartTooltipData';

export class ChartTooltipContent {
  constructor(
    public readonly open: (x: number, y: number) => void,
    public readonly close: () => void,
    public readonly setData: (data: ChartTooltipData) => void
  ) {}
}
